const routes = {
  root: '/',
  login: '/login',
  logout: '/logout',
  home: '/home',

  account: {
    root: '/account',
    editProfile: 'editProfile',
    editPassword: 'editPassword',
    editMembership: 'editMembership',
    editAddress: 'editAddress',
    editPhone: 'editPhone',
    editPrivacyPolicy: 'editPrivacyPolicy',
    editLanguage: 'editLanguage',
    close: 'close',
    committees: '/account',
    committeesEditStandards: 'editStandards',
    committeesEditTech: 'editTech',
    committeesEditAffiliate: 'editAffiliate',
    committeesAddAffiliate: 'addAffiliate',
  },

  standardsBallot: {
    root: '/standardsBallots',
    myBallots: 'myBallots',
    voting: 'myBallots/:committee/:period',
  },

  productDownload: '/product-downloads',
  meetings: '/meetings',
  meeting: '/meetings/:id',
};

export default routes;
